<!-- main app container -->
<div>
  <div class="row no-gutters">
      <div class="col col-md-12">
          <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
          <router-outlet *ngIf="!isIframe"></router-outlet>
      </div>
  </div>

</div>